module.exports = __webpack_public_path__ + "site/img/index4-sd.a96ad4f0.png";